export const ScrollContext = React.createContext();

const WithScroll = Component => props => (
  <ScrollContext.Consumer>
    {scrollProps => <Component {...props} scroll={scrollProps} />}
  </ScrollContext.Consumer>
);

export default WithScroll;
